import { Button, Container, CssBaseline, ThemeProvider, Typography } from '@mui/material'

import { InfoCircleIcon } from '@/components/ui/icons'
import { theme } from '@/lib/theme'

export function ErrorFallback() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container
        maxWidth="sm"
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 2,
          px: 2,
        }}
      >
        <InfoCircleIcon sx={{ fontSize: 80, color: 'error.main' }} />
        <Typography variant="h4" gutterBottom>
          Oops, something went wrong...
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
          Our engineering team has been alerted to this issue, and will work promptly to resolve it.
        </Typography>
        <Button variant="contained" size="large" onClick={() => window.location.replace('/')}>
          Go back to home
        </Button>
      </Container>
    </ThemeProvider>
  )
}
